import { Header, Footer } from '@/components/layout'
import { SEO } from '@/components/seo'

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Contact Us"
        description="Get in touch with Ledger. Contact us for support, partnership enquiries, or to learn how Ledger can help your business."
        canonical="/contact"
      />
      <Header />
      <main className="pt-24 pb-16">
        <div className="mx-auto max-w-7xl section-padding">
          <h1 className="text-4xl font-bold text-surface-900 mb-4">Contact Us</h1>
          <p className="text-lg text-surface-600">We'd love to hear from you</p>
        </div>
      </main>
      <Footer />
    </div>
  )
}

